<script>
  import { layoutMethods,smartRaffleMethods,exportMethods,erpFixMessages} from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from 'sweetalert2';

  /**
   * Draws component
   */
  export default {
    page: {
      title: "Draws"
    },
    components: {
      flatPickr
    },
    computed: {
      ...erpFixMessages
    },
    data() {
      return {
        title: "Draws",
        todayRaffleDraw: true,
        searchValue: {
          searchField: null,
          search: "",
          raffleIdentifier: null,
          promoDuration: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10,
          isConfirm: null,
        },
        searchList: [
          { text: "Search All", value: null },
          { text: "Transaction ID", value: "trd.transaction_id" },
          { text: "Store Name", value: "trd.customer_name" },
          { text: "SSS Mobile Number", value: "trd.mobile_no" },
        ],
        fields: [
          {key: "action", sortable: false, label: ''},
          {key: "transaction_id", sortable: true, label: 'Transaction ID'},
          {key: "customer_name", sortable: true, label: 'Store Name'},
          {key: "mobile_no", sortable: true, label: 'SSS Mobile Number'},
          {key: "store_name", sortable: false, label: 'Store Owner'},
          {key: "identifier_name", sortable: true, label: 'Raffle Identifier Name'},
          {key: "confirmed_by", sortable: true, label: 'Confirm Winner'},
          {key: "promo_duration", sortable: true, label: 'Promo Duration'},
          {key: "prize_name", sortable: true, label: 'Prize'},
          {key: "promo_code", sortable: true, label: 'Promo Code'},
          {key: "created_at", sortable: true, label: 'Draw Date'},
          {key: "email", sortable: false, label: 'Email Address'},
          {key: "address", sortable: false, label: 'SSS Address'},
          {key: "is_buffer", sortable: true, label: 'Idle Winner'},
          {key: "user_id", sortable: true, label: 'Account User ID'},
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        sortBy: "value",
        sortDesc: false,
        rangeOptions: {
          mode: "range",
        },
        raffleIdentifierList: [
          { text: 'All', value: null },
        ],
        itemList:[],
        itemTotalRows: 0,
        raffleIdentifiers:[],
        confirmWinners:[],
        confirmOption: [
          { text: "Search All", value: null },
          { text: "YES", value: 1 },
          { text: "NO", value: 0 }
        ],
      };
    },
    methods: {
      ...layoutMethods,
      ...smartRaffleMethods,
      ...exportMethods,
      openModal(modal=''){
          this.$bvModal.show(modal);
      },
      closeModal(modal=''){
          this.$bvModal.hide(modal);
      },
      async onSearch(state = ''){
          console.log("onsearch");
          if(state == 'reset'){
            this.searchValue.page = 1;
          }
          await this.actionSmartRaffle({
              action: "draw-list",
              body: this.searchValue
          }).then((res)=>{
              // console.log("res",JSON.stringify(res));
              if(res.status == "ok"){
                this.itemList = res.message.rows
                this.itemTotalRows = res.message.pageInfo.total
              }
          }).catch((err)=>{
              console.log("err", err);
          })
      },
      async getRaffleIdentifier(){
          await this.actionSmartRaffle({
              action: "raffle-identifier-list",
              body: {}
          }).then((res)=>{
              // console.log("res",JSON.stringify(res));
              if(res.status == "ok"){
                this.raffleIdentifiers = res.message;
                for(let r of res.message){
                  this.raffleIdentifierList.push({
                    text: r.raffleIdentifierName,
                    value: r.raffleIdentifierId,
                    disabled: r.raffleStatus == 1 ? false : true
                  })
                }
              }
          }).catch((err)=>{
              console.log("err", err);
          })
      },
      async updatePromoDurationFilter(){
        // console.log(this.searchValue.raffleIdentifier);
        // console.log(this.raffleIdentifiers.find(r => r.raffleIdentifierId === this.searchValue.raffleIdentifier));
        if(this.searchValue.raffleIdentifier != null){
          var ri = this.raffleIdentifiers.find(r => r.raffleIdentifierId === this.searchValue.raffleIdentifier);
          this.searchValue.promoDuration = `${ri.raffleStartDate} to ${ri.raffleEndDate}`
        }else{
          this.searchValue.promoDuration = null;
        }
      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting...",ctx);
        this.onSearch('reset');
      },
      async onExport(){
        await this.onSearch("reset");
        if(this.itemTotalRows ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        let params = Object.assign(
          {
            module: 'smart_raffle_draw',
            email: JSON.parse(localStorage.getItem('userData')).email,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            raffleIdentifier: this.searchValue.raffleIdentifier,
            promoDuration: this.searchValue.promoDuration,
            orderDesc: this.searchValue.orderDesc,
            sort: this.searchValue.sort,
            isConfirm: this.searchValue.isConfirm,
          });

        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          console.log("value:",this.searchValue,params)
          // this.searchValue = search_value_holder;
      },
      checkConfirmWinners(){
        // console.log("cehck",JSON.stringify(this.itemList.map(s => s.is_confirm)));
        this.confirmWinners = []
        for(let c of this.itemList){
          if(c.is_confirm === true){
            this.confirmWinners.push(c.transaction_id)
          }
        }
        console.log("HEY", JSON.stringify(this.confirmWinners));
      },
      async updateConfirmWinners(){
        if(this.confirmWinners.length > 0){
          Swal.fire({
            title: "Are you sure?",
            text: `You want to confirm this winners?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then(async (result) => {
            if (result.value) {
              await this.actionSmartRaffle({
                  action: "confirm-winners",
                  body: {transactionIds: this.confirmWinners}
              }).then(async (res)=>{
                  await this.onSearch('reset');
                  console.log("res",JSON.stringify(res));
                  this.confirmWinners = [];
                  Swal.fire(
                    `Confirm Winners`,
                    "Successfully Confirm Winners",
                    "success"
                  )
              }).catch((err)=>{
                  console.log("err", err);
              })
            }
          });
        }else{
          Swal.fire(
            `Confirm Winners`,
            "No added item to confirm",
            "error"
          )
        }
      },
      async checkTodayRaffle(){
          await this.actionSmartRaffle({
              action: "check-today-raffle",
              body: {}
          }).then((res)=>{
              console.log("res checkTodayRaffle",JSON.stringify(res));
              if(res.status == "ok"){
                this.todayRaffleDraw = res.message.hasActive
              }
          }).catch((err)=>{
              console.log("err", err);
          })
      }
    },
    async mounted(){
      this.checkTodayRaffle();
      await this.getRaffleIdentifier();
      await this.onSearch('reset');
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <span class="float-start fw-bold mt-3">
      List of Draw ({{itemTotalRows}})
    </span>
    <div class="mb-2 d-flex flex-wrap flex-row-reverse">
      <button type="button" class="btn btn-secondary d-flex justify-content-center" :disabled="confirmWinners.length == 0" @click="updateConfirmWinners">
        <i class="mdi mdi-check-decagram me-1"></i>
        Confirm Winners
      </button>
      <router-link :to="{ name: 'live draw' }" target= '_blank' v-if="todayRaffleDraw">
        <button type="button" class="btn btn-warning d-flex justify-content-center me-2">
          <img
            :src="require('@/assets/images/raffle-draw.svg')" 
            class="me-1"
          />
          Raffle Draw
        </button>
      </router-link>
      <button type="button" class="btn btn-warning d-flex justify-content-center me-2" @click="openModal('bv-modal-no-active-raffle')" v-else>
        <img
          :src="require('@/assets/images/raffle-draw.svg')"
          class="me-1"
        />
        Raffle Draw
      </button>
    </div>

    <div class="d-flex flex-wrap mt-4 mb-2">
      <div class="me-2 ta-right">
        <b-form-group description="Search Keyword">
          <form class="d-flex" @submit.prevent="onSearch('reset')">
            <b-form-group id="input-group-3" label-for="input-3">
              <b-form-select
                class="form-select rounded-0 rounded-start shadow-none"
                id="input-3"
                v-model="searchValue.searchField"
                :options="searchList"
              ></b-form-select>
            </b-form-group>

            <b-input-group>
              <b-form-input
                class="rounded-0"
                v-model="searchValue.search"
              ></b-form-input>
              <b-input-group-append  v-if="false">
                <b-button
                  variant="primary"
                  type="submit"
                  class="rounded-0 rounded-end px-2"
                >
                  <i class="bx bx-search bx-fw"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </form>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group label-for="raffle-identifier" description="Filter by Raffle Identifier">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
            id="raffle-identifier"
            v-model="searchValue.raffleIdentifier"
            :options="raffleIdentifierList"
            @change="updatePromoDurationFilter"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group description="Filter by Promo Duration">
          <flat-pickr
            v-model="searchValue.promoDuration"
            :config="rangeOptions"
            placeholder="Select a Promo Duration"
            class="form-control"
            style="width: fit-content"
            :disabled="true"
          ></flat-pickr>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group label-for="confirm-winner" description="Filter by Confirm Winner">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:150px"
            id="confirm-winner"
            v-model="searchValue.isConfirm"
            :options="confirmOption"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2">
        <a class="btn btn-primary h-fit" @click="onSearch('reset')">
          <i class='bx bx-search bx-fw'></i>Search
        </a>
      </div>
      <div class="me-2">
        <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
          <i class="uil uil-export me-1"></i>
          Export
        </a>
      </div>
    </div>

    <div class="table-responsive">
      <div class="table align-middle table-nowrap">
        <b-table
          :items="itemList"
          :fields="fields"
          responsive="sm"
          :current-page="searchValue.page"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          class="table-check"
          @sort-changed="tableSort" 
        >
          <template #cell(action)="data">
            <input type="checkbox" id="checkbox" v-model="data.item.is_confirm" v-if="data.item.confirmed_by == null" @change="checkConfirmWinners()"/>
          </template>
          <template #cell(promo_duration)="data">
            {{ data.item.raffle_start |  formatDateOnly}}
            to
            {{ data.item.raffle_end |  formatDateOnly}}
          </template>
          <template #cell(created_at)="data">
            {{ data.item.created_at |  formatDateOnly}}
          </template>
          <template #cell(address)="data">
            <span :title="data.item.address">
              {{ data.item.address | truncator(20,"...")}}
            </span>
          </template>
          <template #cell(is_buffer)="data">
            {{ data.item.is_buffer == null ? "No":"Yes"}}
          </template>
          <template #cell(confirmed_by)="data">
            {{ data.item.confirmed_by == null ? "No":"Yes"}}
          </template>
        </b-table>
      </div>
    </div>
    <!-- end table responsive -->
    <div class="row g-0 text-center" v-if="itemTotalRows == 0">
      <span>No data to display.</span>
    </div>

    <div class="row" v-if="itemTotalRows > 0">
      <div class="col">
        <div class="form-group row pull-left">
          <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
          <div class="col-sm-6">
            <b-form-group label-for="display-record">
              <b-form-select class="form-select shadow-none w-fit"
                id="display-record"
                v-model="searchValue.rows"
                :options="pageOptions"
                @change="onSearch('reset')"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>
        <div
          class="
            dataTables_paginate
            paging_simple_numbers
            float-end
          "
        >
          <b-pagination
            v-if="itemTotalRows != 0 && itemTotalRows > searchValue.rows"
            class="pagination-rounded"
            v-model="searchValue.page"
            :total-rows="itemTotalRows"
            @input="onSearch()"
            :per-page="searchValue.rows"
          ></b-pagination>
        </div>
      </div>
    </div>



    
    <b-modal id="bv-modal-no-active-raffle" title="winner" size="md" hide-header hide-title hide-footer hide-header-close>
        <span class="float-end c-pointer " @click="closeModal('bv-modal-no-active-raffle')"><i class="bx bx-x"></i></span>
        <div class="mt-4">
            <div class="d-flex align-items-center justify-content-center">
                <img
                    :src="require('@/assets/images/raffle-draw.svg')" style="filter: brightness(0.5);height: 80px;"
                />
            </div>
            <h4 class="text-center mt-4">No Active Raffle</h4>
            <p class="text-center"><small class="text-muted"> There's no active raffle set today. Stay Tuned!</small></p>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <button type="button" class="btn btn-primary w-100" @click="closeModal('bv-modal-no-active-raffle')">
                Ok
            </button>
        </div>
    </b-modal>
  </div> <!-- end of outer div-->
</template>

<style>
.btn-warning {
    color: #FFF;
    background-color: #E39141;
    border-color: #E39141;
}
</style>